import React from 'react';
import {
  Box,
  Container,
  Typography,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import {
  Lock as LockIcon,
  Star as StarIcon,
  Headset as HeadsetIcon,
  MoneyOff as MoneyOffIcon,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const ITEMS = [
  { icon: LockIcon, key: 'securePay' },
  { icon: StarIcon, key: 'reviews' },
  { icon: HeadsetIcon, key: 'support' },
  { icon: MoneyOffIcon, key: 'free' },
];

/**
 * Reassurance bar — 4 trust arguments.
 * Desktop: horizontal row.
 * Mobile: vertical stack, icon+text.
 */
const ReassuranceBar = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      component="section"
      sx={{
        py: { xs: 3, md: 4 },
        bgcolor: 'grey.50',
        borderTop: '1px solid',
        borderColor: 'grey.200',
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            alignItems: isMobile ? 'flex-start' : 'center',
            justifyContent: 'space-around',
            gap: isMobile ? 2 : 1,
          }}
        >
          {ITEMS.map(({ icon: Icon, key }) => (
            <Box
              key={key}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                minWidth: 0,
              }}
            >
              <Icon
                sx={{
                  fontSize: { xs: 28, md: 32 },
                  color: theme.palette.primary.main,
                  flexShrink: 0,
                }}
              />
              <Box sx={{ minWidth: 0 }}>
                <Typography
                  variant="body2"
                  sx={{ fontWeight: 700, lineHeight: 1.3 }}
                >
                  {t(`homepage.reassurance.${key}.title`)}
                </Typography>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ lineHeight: 1.3 }}
                >
                  {t(`homepage.reassurance.${key}.desc`)}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default ReassuranceBar;
